import script from "./DashboardCard.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardCard.vue?vue&type=script&setup=true&lang=js"

import "./DashboardCard.vue?vue&type=style&index=0&id=5f357af2&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f357af2"]])

export default __exports__